import { api } from './client';

/** Mirrors WorkTimeSheetDto (Api/UseCases/Payroll/ManageWorkTime). */
export interface WorkTimeClassDto {
  id: number;
  typeId: number;
  name: string;
  inclusionRate: number | null;
  isSpecialSchema: boolean;
}

export interface WorkTimeDayDto {
  date: string;
  workTimeClassId: number;
  hours: number;
  countedDays: number;
}

export interface WorkTimeSpecialDto {
  workTimeClassId: number;
  totalHours: number;
}

export interface WorkTimeItemDto {
  workerId: number;
  workerName: string;
  contractNumber: number;
  contractSerial: string;
  quotaDays: number;
  quotaHours: number;
  totalDays: number;
  totalHours: number;
  days: WorkTimeDayDto[];
  specialHours: WorkTimeSpecialDto[];
}

export interface WorkTimeSheetDto {
  year: number;
  month: number;
  exists: boolean;
  classes: WorkTimeClassDto[];
  items: WorkTimeItemDto[];
}

export interface SaveWorkTimeItem {
  workerId: number;
  contractNumber: number;
  contractSerial?: string | null;
  quotaDays?: number;
  quotaHours?: number;
  days: { date: string; workTimeClassId: number; hours?: number; countedDays?: number }[];
  specialHours: { workTimeClassId: number; totalHours: number }[];
}

export const workTimeApi = {
  sheet: (year: number, month: number) =>
    api.get<WorkTimeSheetDto>('/payroll/work-time', { year, month }),

  save: (year: number, month: number, items: SaveWorkTimeItem[]) =>
    api.post<void>('/payroll/work-time', { year, month, items }),
};
